import { HttpClient } from './HttpClient';
import { env } from '../../config/env';

// Create HTTP client instance
const API_BASE_URL = env.REACT_APP_API_URL;

export const httpClient = new HttpClient(API_BASE_URL);

// Export types and classes
export * from './HttpClient';
export * from './types';
